const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import InfiniteScroll from "react-infinite-scroll-component";

//Import Designs
import {
    Grid2,
    Select,
    MenuItem,
    Button,
    CircularProgress,
    Pagination
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

class Paginationcontestants extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    render() {

        const allprops = this.props;

        let votes_pagination_default_bg = '#303f9f', votes_pagination_active_bg = '#ffffff', votes_pagination_disabled_bg = '#303f9f80', votes_pagination_default_font = '#ffffff', votes_pagination_active_font = '#303f9f';
        if (this.props.short.allcatoption !== undefined && this.props.short.allcatoption.color !== undefined) {
            ({ votes_pagination_default_bg, votes_pagination_active_bg, votes_pagination_disabled_bg, votes_pagination_default_font, votes_pagination_active_font } = this.props.short.allcatoption.color);
        } else {
            ({ votes_pagination_default_bg, votes_pagination_active_bg, votes_pagination_disabled_bg, votes_pagination_default_font, votes_pagination_active_font } = this.props.settings.color);
        }

        const posts = (typeof this.props.post.posts === "undefined") ? this.props.post_single : this.props.post.posts;
        let pagination = allprops.short.pagination;
        let pagin_design = null;
        let pagin_response = (typeof allprops.short.pagin_response !== "undefined") ? allprops.short.pagin_response : null;
        let pagin_val_prop = (typeof allprops.post.pagin_val !== "undefined") ? allprops.post.pagin_val : null;

        let has_more = false;
        let page_number = 1;

        //on ajaxcall get numbers from wordpress
        if (pagin_val_prop != null) {
            pagin_response.total_posts = pagin_val_prop.total_posts;
            pagin_response.page_nums = pagin_val_prop.page_nums;
            has_more = pagin_val_prop.total_posts > posts.length;
            page_number = posts.length / allprops.short.postperpage;
        }

        let count_pages = null;
        let pagination_text = null;
        let selected_val = this.props.select_value;
        let pagin_drop = [];
        if (typeof this.props.settings.pagination !== "undefined") {
            pagin_design = this.props.settings.pagination;
            count_pages = pagin_design.num_pages;
            if (pagin_design.pages_text != '' && pagin_design.pages_text != null) {
                pagination_text = pagin_design.pages_text;
                let reslt_txt = pagination_text.replace('%CURRENT_PAGE%', this.props.pagenumber);
                reslt_txt = reslt_txt.replace('%TOTAL_PAGES%', pagin_response.page_nums);
                pagination_text = reslt_txt;
            }

        }

        if (pagin_design != null && pagin_design.style <= 2 && pagin_response != null) {
            count_pages = pagin_response.page_nums;
            if (pagin_response.page_nums > 0) {
                let count = pagin_response.page_nums;
                for (let i = 1; i <= count; i++) {
                    pagin_drop.push({ value: i, label: i });
                }
            }
        }

        const theme = createTheme({
            components: {
                // Name of the component
                MuiPagination: {
                    styleOverrides: {
                        root: {
                            "& .Mui-selected": {
                                backgroundColor: votes_pagination_active_bg || '#FFF',
                                borderColor: votes_pagination_default_bg || '#303f9f',
                                color: votes_pagination_active_font || '#303f9f',
                            },
                            "& .Mui-disabled": {
                                backgroundColor: votes_pagination_disabled_bg || '#303f9f80',
                            }
                        }
                    }
                },
                MuiPaginationItem: {
                    styleOverrides: {

                        root: {
                            backgroundColor: votes_pagination_default_bg || '#303f9f',
                            color: votes_pagination_default_font || '#FFF',
                            "&:hover, &:focus": {
                                backgroundColor: votes_pagination_default_bg || '#303f9f',
                                opacity: 0.7
                            },
                            "&.Mui-selected:hover, &.Mui-selected:focus": {
                                backgroundColor: votes_pagination_active_bg || '#FFF',
                                borderColor: votes_pagination_default_bg || '#303f9f',
                                color: votes_pagination_active_font || '#303f9f',
                                opacity: 0.7
                            },
                        },
                        page: {
                            backgroundColor: votes_pagination_default_bg || '#303f9f',
                            color: votes_pagination_default_font || '#FFF',
                            "&:hover, &:focus": {
                                backgroundColor: votes_pagination_default_bg || '#303f9f',
                                opacity: 0.7
                            },
                            "&.Mui-selected:hover, &.Mui-selected:focus": {
                                backgroundColor: votes_pagination_active_bg || '#FFF',
                                borderColor: votes_pagination_default_bg || '#303f9f',
                                color: votes_pagination_active_font || '#303f9f',
                                opacity: 0.7
                            },
                        },
                        ellipsis: {
                            padding: '5px',
                            marginTop: '4px',
                        }
                    }
                },
            },
        });

        if (pagination == 1) {
            return (
                (<Grid2 container size={12}>
                    {(pagin_design.style == 1) && (typeof count_pages !== "undefined" && count_pages > 1) &&
                        <Grid2 container size={12} direction="row" justifyContent="center" alignItems="center" className="wpvc_pagination_container">
                            <Grid2 className="wpvc_pagination_item" size={10}>
                                <ThemeProvider theme={theme}>
                                    <Pagination
                                        count={parseInt(count_pages)}
                                        page={this.props.select_value == "" ? 1 : this.props.select_value}
                                        onChange={this.props.changepagin}
                                    />
                                </ThemeProvider>
                            </Grid2>
                            <Grid2 className="wpvc_pagination_text" size={2}>
                                {pagination_text}
                            </Grid2>
                        </Grid2>
                    }
                    {(pagin_design.style == 2) && (typeof count_pages !== "undefined") &&
                        <Grid2 container size={12} direction="row" justifyContent="center" alignItems="center" className="wpvc_pagination_container">
                            <Grid2 className="wpvc_pagination_item" size={11}>
                                <Select
                                    className="wpvc_pagination_select"
                                    name="pagination_number"
                                    value={(selected_val != '') ? selected_val : this.props.pagenumber}
                                    onChange={this.props.changepagin}
                                >
                                    {pagin_drop.map(({ value, label }, index) => <MenuItem key={index} className="wpvc_pagination_select_options" value={value}>{label}</MenuItem>)}
                                </Select>
                            </Grid2>
                            <Grid2 className="wpvc_pagination_text" size={1}>
                                {pagination_text}
                            </Grid2>
                        </Grid2>
                    }
                    {pagin_design.style == 3 &&
                        <Grid2 container size={12} direction="row" justifyContent="center" alignItems="center" className="wpvc_pagination_container">
                            {pagin_response.page_nums > this.props.pagenumber &&
                                <Button
                                    variant="contained"
                                    className="wpvc_pagination_btns"
                                    color="primary"
                                    startIcon={<AutorenewIcon />}
                                    onClick={() => { this.props.changepaginbtn('button', page_number) }}
                                    style={{ 'color': votes_pagination_default_font || '#FFF', 'background': votes_pagination_default_bg || '#303f9f' }}
                                >
                                    {pagin_design.load_more_button_text}
                                </Button>
                            }
                        </Grid2>
                    }
                    {pagin_design.style == 4 &&
                        <Grid2 container size={12} direction="row" justifyContent="center" alignItems="center" className="wpvc_pagination_container">
                            <InfiniteScroll
                                dataLength={posts.length}
                                next={() => { this.props.changepaginbtn('button', page_number) }}
                                hasMore={has_more}
                                loader={<h4> <CircularProgress color="inherit" />Loading...</h4>}
                            />
                        </Grid2>
                    }
                </Grid2>)
            );

        } else {
            return ''
        }
    }
}

export default connect()(Paginationcontestants);
